import $ from 'jquery';
import config from 'lib/config';
import * as Utils from 'lib/utils';
import { uncrunch } from 'graphql-crunch';

const W = window;

W.API = Utils.freeze($.unpack(W.API));

$.setUserToken = token => {
  W.API = Utils.freeze(Object.assign({}, W.API, { user: token }));
  $.GraphQL.headers['X-USER-TOKEN'] = token;
};

class GraphQL {
  constructor() {
    this.httpUri = config.api.uri + config.api.endpoint;
    this.headers = {
      'X-CLIENT-HOST': W.API.host,
      'X-CLIENT-TOKEN': W.API.client,
      'X-USER-TOKEN': W.API.user || undefined,
    };

    this.$proxy = $({});
  }

  on(type, fn) {
    const events = $._data(this.$proxy[0], 'events') || {};
    if (!events[type]) this.$proxy.on(type, fn);
    return this;
  }

  async runQuery(query, opts) {
    const headers = { ...this.headers };
    const { crunch = true, session, ...options } = opts;

    if (session) headers['X-SESSION-TOKEN'] = session;
    if (crunch) headers['X-CRUNCH'] = crunch;
    if (opts && opts.operationName) headers['X-OPERATION-NAME'] = opts.operationName;

    const result = await new Promise((resolve, reject) => {
      $.ajax({
        url: this.httpUri,
        headers,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ query, ...options }),
        cache: false,
      })
        .done((data, status, xhr) => {
          const crunched = xhr.getResponseHeader('x-crunched') === 'true';

          if (crunched && data.data) data.data = uncrunch(data.data);
          if (crunched && data.extensions) data.extensions = uncrunch(data.extensions);

          data = Object.assign({}, { name: opts && opts.operationName }, data.data, data.extensions);

          if (data.event) $.sendEvent(data.event);

          resolve(data);
        })
        .fail((xhr, status, err) => {
          const crunched = xhr.getResponseHeader('x-crunched') === 'true';
          let data = xhr.responseJSON;

          if (xhr.readyState === 4 && data) {
            if (crunched && data.data) data.data = uncrunch(data.data);
            if (crunched && data.extensions) data.extensions = uncrunch(data.extensions);

            data = Object.assign({}, { name: opts && opts.operationName, data: null }, data.data, data.extensions);

            return resolve(data);
          }

          if (xhr.readyState === 0) err = new Error('Unable to connect to the server. Please try again.');

          console.log(xhr, status, err);

          reject(err);
        });
    });

    return result;
  }
}

$.GraphQL = new GraphQL();
